export default "__VITE_ASSET__54a22808__"